import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { Home, ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';

const NotFound = () => {
  const { language } = useLanguage();
  const it = language === 'it';

  return (
    <div className="min-h-screen bg-stone-100 flex items-center justify-center px-4">
      <div className="text-center max-w-md">
        <div className="text-8xl font-heading font-bold gradient-text mb-4">404</div>
        <h1 className="font-heading text-2xl font-bold text-stone-900 mb-3">
          {it ? 'Pagina non trovata' : 'Page not found'}
        </h1>
        <p className="text-stone-500 mb-8">
          {it ? 'La pagina che stai cercando non esiste o è stata spostata.' : 'The page you are looking for does not exist or has been moved.'}
        </p>
        <div className="flex gap-3 justify-center">
          <Link to="/">
            <Button className="bg-emerald-800 hover:bg-emerald-900 text-white rounded-full px-6">
              <Home className="h-4 w-4 mr-2" />
              {it ? 'Torna alla home' : 'Go to home'}
            </Button>
          </Link>
          <Button variant="outline" className="rounded-full px-6" onClick={() => window.history.back()}>
            <ArrowLeft className="h-4 w-4 mr-2" />
            {it ? 'Indietro' : 'Go back'}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
